export const CURRENCY_LIST = 'mac/FETCH_CURRENCY_LIST';
